<template lang="pug">
  b-row
    b-col(sm='12')
      b-form(@submit.prevent="submit")
        b-card
          div(slot="header")
            strong {{ formName }}
            small.pl-2 Form

          b-row
            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(label="Type")
                  b-form-select(
                    :plain="true",
                    :options='typeOptions'
                    id='structure_type'
                    name='type'
                    v-validate="'required'"
                    v-model='structure.type'
                  )
                  div.text-danger(v-show="errors.has('type')") {{ errors.first('type') }}

              b-col(sm='12')
                b-form-fieldset(label="Name")
                  b-form-input(
                    type="text",
                    id="structure_name"
                    name="name"
                    placeholder="Enter object's name"
                    v-model='structure.name'
                  )

              b-col(sm='12')
                b-form-fieldset(label="Model")
                  b-form-input(
                    type="text"
                    id="structure_model"
                    name="model"
                    placeholder="Enter object's model"
                    v-model='structure.model'
                  )

              b-col(sm='12')
                b-form-fieldset(label="ID Code")
                  b-form-input(
                    type="text"
                    id="structure_code"
                    name="code"
                    placeholder="Enter object's ID Code"
                    v-validate="'required'"
                    v-model='structure.code'
                  )
                  div.text-danger(v-show="errors.has('code')") {{ errors.first('code') }}

            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(label="Manufacturer")
                  b-form-input(
                    type="text"
                    id="structure_manufacturer"
                    name="manufacturer"
                    placeholder="Enter object's manufacturer"
                    v-model='structure.manufacturer'
                  )

              b-col(sm='12')
                b-form-fieldset(label="Year of manufacture")
                  b-form-input(
                    type="number"
                    id="structure_manufacture_year"
                    name="manufacture_year"
                    v-model='structure.manufacture_year'
                  )

          b-col.py-4(sm='12')
            button.btn.btn-primary.px-4(type='submit') Save
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import RouteGen from '@/utils/apiRoutes'
  import { options } from '@/utils/resourceNormalizer'

  export default {
    name: 'StructureForm',
    data () {
      return {
        typeOptions: options['structure_type'],
        formName: 'Create a new Object',
        structure: {
          type: null,
          name: null,
          model: null,
          code: null,
          manufacturer: null,
          manufacture_year: null
        }
      }
    },
    mounted () {
      if (this.isEdit()) {
        this.$set(this.$data, 'formName', "Modify object's informations")
        this.fetchStructure(this.$route.params.id)
      }
    },
    methods: {
      isEdit () {
        return this.$route.params.hasOwnProperty('id')
      },
      fetchStructure (structureId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        let route = RouteGen.show('structure', structureId)
        server.get(route)
          .then(res => {
            this.$set(this.$data, 'structure', res.data.structure)
          })
          .catch(err => {
            console.log(err)
          })
      },
      submit () {
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.saveStructure(this.$route.params.id)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      saveStructure (id = null) {
        let url = RouteGen.create('structure')
        let verb = 'post'
        let messageModifier = 'created'
        if (id) {
          url = RouteGen.edit('structure', id)
          verb = 'patch'
          messageModifier = 'updated'
        }
        server[verb](url, { structure: this.$data.structure })
          .then(res => {
            this.showNotification(201, messageModifier)
            this.$router.push({ name: 'All objects' })
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
      },
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'Object', modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Structure/Form.vue